import create from 'zustand';
import shallow from 'zustand/shallow';
import { BigNumber } from 'bignumber.js';
import { Howler } from 'howler';
import { devtools } from 'zustand/middleware';

/* this is the global state store for games, most if not all this state is shared by all games
games can simply use the store hooks to access/modify those variables anywhere */

function loadSoundDisabled() {
  let soundDisabled = localStorage.getItem('sound') || false;
  if (soundDisabled) {
    soundDisabled = JSON.parse(soundDisabled);
  }
  Howler.mute(soundDisabled);
  return soundDisabled;
}

export const useGameStore = create(
  devtools(
    set => ({
      isRealMode: false,
      setIsRealMode: isRealMode => set({ isRealMode }),

      bettingData: {
        amount: new BigNumber(0),
        script: '',
        multiplier: 1,
      },
      setBettingData: newData => set(state => ({ bettingData: { ...state.bettingData, ...newData } })),

      // all items in betting history must extend this shape:
      // {id: number, label: string, payoutRate: string, amount: string/number, isWin: boolean}
      bettingHistory: [],
      setBettingHistory: bettingHistory => set({ bettingHistory }),

      bettingDisabled: false,
      setBettingDisabled: bettingDisabled => set({ bettingDisabled }),

      soundDisabled: loadSoundDisabled(),
      setSoundDisabled: soundDisabled => {
        Howler.mute(soundDisabled);
        set({ soundDisabled });
      },

      allBets: [],
      setAllBets: allBets => set({ allBets }),

      highRollers: [],
      setHighRollers: highRollers => set({ highRollers }),
    }),
    { name: 'Game Store' }
  )
);
export const useGameShallow = func => useGameStore(func, shallow);
